export default "__VITE_ASSET__CDwqJAET__"